import React, { useEffect, useMemo, useState } from "react";
import { Search, X, Check } from "lucide-react";
import api from "@/lib/api";

export function HotelMultiPicker({ value = [], onChange }) {
    const [hotels, setHotels] = useState([]);
    const [q, setQ] = useState("");

    useEffect(() => {
        api.get("/admin/hotels?limit=500").then((r) => setHotels(r.data.items || r.data || [])).catch(() => {});
    }, []);

    const byId = useMemo(() => Object.fromEntries(hotels.map((h) => [h.id, h])), [hotels]);
    const filtered = hotels.filter((h) => `${h.name} ${h.destination_name || ""}`.toLowerCase().includes(q.toLowerCase()));
    const toggle = (id) => onChange(value.includes(id) ? value.filter((x) => x !== id) : [...value, id]);

    return (
        <div data-testid="hotel-multi-picker" className="rounded-xl border-2 border-rose-200 dark:border-rose-900 bg-rose-50/40 dark:bg-rose-950/10 p-3">
            <div className="flex flex-wrap gap-1.5 mb-2 min-h-[28px]">
                {value.length === 0 && <span className="text-xs text-rose-500 italic py-1">Henüz otel seçilmedi</span>}
                {value.map((id) => (
                    <span key={id} data-testid={`hotel-chip-${id}`} className="inline-flex items-center gap-1 pl-2.5 pr-1 py-1 rounded-full bg-rose-500 text-white text-xs font-semibold">
                        {byId[id]?.name || "…"}
                        <button type="button" data-testid={`hotel-chip-remove-${id}`} onClick={() => toggle(id)} className="p-0.5 rounded-full hover:bg-rose-600"><X className="h-3 w-3" /></button>
                    </span>
                ))}
            </div>
            <div className="flex items-center gap-2 px-3 py-2 rounded-lg bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700">
                <Search className="h-4 w-4 text-slate-400" />
                <input data-testid="hotel-picker-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Otel ara..." className="w-full bg-transparent outline-none text-sm text-slate-900 dark:text-white" />
            </div>
            <div className="mt-2 max-h-48 overflow-y-auto space-y-1">
                {filtered.map((h) => {
                    const on = value.includes(h.id);
                    return (
                        <button type="button" key={h.id} data-testid={`hotel-option-${h.id}`} onClick={() => toggle(h.id)} className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-left text-sm transition-colors ${on ? "bg-rose-100 dark:bg-rose-950/40" : "hover:bg-white dark:hover:bg-slate-800"}`}>
                            <span className={`h-4 w-4 rounded border flex items-center justify-center ${on ? "bg-rose-500 border-rose-500" : "border-slate-300 dark:border-slate-600"}`}>{on && <Check className="h-3 w-3 text-white" />}</span>
                            <span className="flex-1 font-medium text-slate-900 dark:text-white truncate">{h.name}</span>
                            <span className="text-[11px] text-slate-500">{h.destination_name}</span>
                        </button>
                    );
                })}
                {filtered.length === 0 && <div className="text-xs text-slate-500 px-3 py-2">Sonuç yok</div>}
            </div>
        </div>
    );
}
